import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "credit-line-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "main-content bsp-page__content"
}
const _hoisted_3 = {
  class: "bsp-summary-grid",
  "aria-label": "Credit line information"
}
const _hoisted_4 = {
  class: "bsp-section",
  "aria-labelledby": "credit-actions-title"
}
const _hoisted_5 = { class: "bsp-action-list" }

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { computed, onMounted, ref } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import { WhatsappBusinessAccount } from '../services/AccountService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import AccountService from '@/services/AccountService/AccountService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AEmptyViewCard, AIcon, AInformationCard, ATag } from '@adereso-ai/vue-components'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditLineView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')
const whatsappBusinessAccount = ref<WhatsappBusinessAccount | undefined>(undefined)

const creditBreadcrumbs = computed(() => [
  {
    title: 'WhatsApp Accounts',
    icon: 'tabler:brand-whatsapp',
    to: { name: 'whatsapp-business-accounts' }
  },
  {
    title: whatsappBusinessAccount.value?.name || 'Account',
    to: { name: 'whatsapp-business-account', params: { wabaId: String(route.params.wabaId) } }
  },
  { title: 'Credit line', disabled: true }
])

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function shareCreditLine () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.shareCreditLine(whatsappBusinessAccount.value.id)
      toastSuccess('Share Credit Line Response: ' + response)
    } catch (error) {
      toastError('Share Credit Line Error: ' + error)
    }
  }
  loading.value = false
}

async function verifyCreditLine () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.verifyCreditLine(whatsappBusinessAccount.value.id)
      toastSuccess('Verify Credit Line Response: ' + JSON.stringify(response))
    } catch (error) {
      toastError('Verify Credit Line Error: ' + error)
    }
  }
  loading.value = false
}

async function revokeCreditLine () {
  loading.value = true
  if (whatsappBusinessAccount.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.revokeCreditLine(whatsappBusinessAccount.value.id)
      toastSuccess('Revoke Credit Line Response: ' + response)
    } catch (error) {
      toastError('Revoke Credit Line Error: ' + error)
    }
  }
  loading.value = false
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

async function getWhatsappBusinessAccount (wabaId: string) {
  try {
    const accountService = await AccountService.getInstance()
    whatsappBusinessAccount.value = await accountService.getWhatsappBusinessAccount(wabaId)
  } catch {
    toastError('Error getting whatsapp business account')
    router.push({ name: 'home' })
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  const wabaId = route.params.wabaId as string

  if (wabaId) {
    await getWhatsappBusinessAccount(wabaId)
  } else {
    router.push({ name: 'home' })
  }

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

function toastSuccess (successMessage: string) {
  try {
    toast.success(String(successMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && whatsappBusinessAccount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BspPageHeader, {
            breadcrumbs: creditBreadcrumbs.value,
            title: "Credit line",
            description: `Manage the financial assignment for ${whatsappBusinessAccount.value.name}.`,
            eyebrow: "Meta billing",
            icon: "tabler:credit-card"
          }, {
            meta: _withCtx(() => [
              _createVNode(_unref(ATag), {
                text: `WABA ${whatsappBusinessAccount.value.id}`,
                color: "info",
                type: "secondary"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["breadcrumbs", "description"]),
          _createElementVNode("section", _hoisted_3, [
            _createVNode(_unref(AInformationCard), {
              title: "Owning business",
              description: whatsappBusinessAccount.value.owner_business_info.name,
              "icon-name": "tabler:building",
              variant: "flat"
            }, null, 8, ["description"]),
            _createVNode(_unref(AInformationCard), {
              title: "Business ID",
              description: whatsappBusinessAccount.value.owner_business_info.id,
              "icon-name": "tabler:fingerprint",
              variant: "flat"
            }, null, 8, ["description"]),
            _createVNode(_unref(AInformationCard), {
              title: "Funding source",
              description: whatsappBusinessAccount.value.primary_funding_id || 'No information',
              "icon-name": "tabler:wallet",
              variant: "flat"
            }, null, 8, ["description"])
          ]),
          _createElementVNode("section", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "bsp-section-heading" }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Available actions"),
                _createElementVNode("h2", { id: "credit-actions-title" }, "Credit line permissions"),
                _createElementVNode("p", null, "These actions change the financial relationship between the owning business and the WABA.")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_card, {
                class: "bsp-action-row",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AIcon), {
                    icon: "tabler:share",
                    color: "primary",
                    size: "20",
                    "with-container": ""
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "Share credit line"),
                    _createElementVNode("p", null, "Assign the available credit line to this WhatsApp Business account.")
                  ], -1)),
                  _createVNode(_unref(AButton), {
                    color: "blue",
                    variant: "outlined",
                    onClick: shareCreditLine
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Share", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "bsp-action-row",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AIcon), {
                    icon: "tabler:shield-check",
                    color: "success",
                    size: "20",
                    "with-container": ""
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "Verify assignment"),
                    _createElementVNode("p", null, "Check in Meta that the relationship is configured correctly.")
                  ], -1)),
                  _createVNode(_unref(AButton), {
                    color: "blue",
                    variant: "outlined",
                    onClick: verifyCreditLine
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Verify", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "bsp-action-row bsp-action-row--danger",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AIcon), {
                    icon: "tabler:unlink",
                    color: "error",
                    size: "20",
                    "with-container": ""
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "Revoke credit line"),
                    _createElementVNode("p", null, "The WABA will stop using this funding source.")
                  ], -1)),
                  _createVNode(_unref(AButton), {
                    color: "red",
                    variant: "outlined",
                    onClick: revokeCreditLine
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Revoke", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : (!loading.value)
        ? (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
            key: 1,
            icon: "tabler:credit-card-off",
            title: "Account not found",
            description: "Return to the list and try again."
          }))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 }))
  ]))
}
}

})